// src/lib/theme.ts
import { PaletteOptions, createTheme } from "@mui/material/styles";
import React from "react";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";
import { LinkProps } from "@mui/material/Link";

const LinkBehavior = React.forwardRef<
  HTMLAnchorElement,
  Omit<RouterLinkProps, "to"> & { href: RouterLinkProps["to"] }
>((props, ref) => {
  const { href, ...other } = props;
  return <RouterLink ref={ref} to={href} {...other} />;
});

const components = {
  MuiLink: {
    defaultProps: {
      component: LinkBehavior,
    } as LinkProps,
  },
};

const basePaletteOptions: PaletteOptions = {
  primary: {
    main: "#e84bfa",
  },
  secondary: {
    main: "#351c75",
  },
};

const darkPaletteOptions: PaletteOptions = {
  mode: "dark",
};

export const darkTheme = createTheme({
  palette: { ...darkPaletteOptions, ...basePaletteOptions },
  components,
});

export const lightTheme = createTheme({
  palette: { ...basePaletteOptions },
  components,
});
